<template>
  <div class="page-edit">
    <div class="edit-scenic">
      <div class="scenic-filed">
        <span class="filed-name">{{scenic.name}}</span>
        <span class="filed-text" v-if='scenic.level !== -1'>{{scenic.levelName}}</span>
      </div>
      <div class="scenic-filed">
        <span class="filed-text">地址：{{scenic.address}}</span>
      </div>
      <div class="scenic-filed">
        <span class="filed-text">开放时间：{{scenic.openTime}}</span>
      </div>
    </div>
    <div class="edit-form">
      <div class="form-filed">
        <div class="filed-name">
          <span>预约日期:</span>
        </div>
        <div class="filed-input">
          <input type="text" v-model="params.rdate" readonly @click="showPop('date')">
          <img src="@/assets/images/arrow-down.png" class="icon-arrow">
        </div>
      </div>
      <div class="form-filed">
        <div class="filed-name">
          <span>预约时段:</span>
        </div>
        <div class="filed-input">
          <input type="text" v-model="timeSelect.key" readonly @click="showPop('time')">
          <img src="@/assets/images/arrow-down.png" class="icon-arrow">
        </div>
      </div>
      <div class="form-title">预约人信息</div>
      <div class="form-filed">
        <div class="filed-name">
          <span>姓名:</span>
        </div>
        <div class="filed-input">
          <input type="text" v-model="params.name" placeholder="请输入姓名">
          <img
            v-show="params.name"
            @click="clearText('name')"
            src="@/assets/images/close1@2x.png" class="icon-close">
        </div>
      </div>
      <div class="form-filed">
        <div class="filed-name">
          <span>手机号码:</span>
        </div>
        <div class="filed-input">
          <input type="number" pattern="\d*" v-model="params.mobile"  placeholder="请输入手机号码">
          <img
            v-show="params.mobile"
            src="@/assets/images/close1@2x.png"
            @click="clearText('mobile')"
            class="icon-close">
        </div>
      </div>
      <div class="form-filed">
        <div class="filed-name">
          <span>身份证号码:</span>
        </div>
        <div class="filed-input">
          <input type="text"  v-model="params.idCard" placeholder="请输入身份证号码">
          <img
            v-show="params.idCard"
            src="@/assets/images/close1@2x.png"
            @click="clearText('idCard')"
            class="icon-close">
        </div>
      </div>
      <div class="form-filed" v-if="showFace">
        <div class="filed-name not-require">
          <span>录入人脸:</span>
        </div>
        <div class="filed-upload">
          <div class="uplaod-img" v-if="params.facePicUrl">
            <img :src="params.facePicUrl" alt="">
            <a @click="deleteImg"></a>
          </div>
          <div class="uplaod-area" v-if="!params.facePicUrl" >
            <input type="file" name="" accept="image/*" capture="user" @change='addImg'>
            <img src="../assets/images/face@2x.png" alt="">
          </div>
          <div class="uplaod-text">
            录入人脸后，可通过刷人脸闸机快速入园
          </div>
        </div>
      </div>
      <div class="form-btn" :class="submitAble ? 'btn-enabled' : ''" @click="submit()">提交预约</div>
    </div>
    <mt-popup v-model="dateVisiable" position="bottom" >
      <div class="picker-toolbar">
        <span class="mint-datetime-action mint-datetime-cancel" @click='cancelSelect("date")'>取消</span>
        <span class="mint-datetime-action mint-datetime-confirm" @click='confirmSelect("date")'>确定</span>
      </div>
      <div @touchmove.prevent>
        <mt-picker :slots="dateSlots" :showToolbar="true" valueKey='rdate' ref='datePicker'></mt-picker>
      </div>
    </mt-popup>
    <mt-popup v-model="timeVisiable" position="bottom" >
      <div class="picker-toolbar">
        <span class="mint-datetime-action mint-datetime-cancel" @click='cancelSelect("time")'>取消</span>
        <span class="mint-datetime-action mint-datetime-confirm" @click='confirmSelect("time")'>确定</span>
      </div>
      <div @touchmove.prevent>
        <mt-picker :slots="timeSlots" :showToolbar="true" valueKey='key' ref='timePicker'></mt-picker>
      </div>
    </mt-popup>
  </div>
</template>

<script type="text/javascript">
import { Toast, Indicator } from 'mint-ui'
import lrz from 'lrz'
export default{
  data () {
    return {
      scenic: {},
      dateVisiable: false,
      timeVisiable: false,
      dateSlots: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      timeSlots: [
        {
          flex: 1,
          values: [],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      timeSelect: {},
      params: {
        rdate: '',
        scheduleId: '',
        name: '',
        mobile: '',
        credentialsType: 1,
        idCard: '',
        facePicUrl: ''
      },
      showFace: false
    }
  },
  computed: {
    submitAble () {
      let _params = this.params
      return _params.name && _params.mobile && _params.idCard
    }
  },
  methods: {
    // 获取最近一次预约人信息
    async getLastBooking () {
      let that = this
      try {
        let result = await that.$api({
          method: 'get',
          url: '/bookingSite/lastBooking'
        })
        if (result.code === 2000 && result.result) {
          let res = result.result
          that.params.name = res.name
          that.params.mobile = res.mobile
          that.params.idCard = res.idCard
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取可用的预约日期
    async getBookingDate () {
      let that = this
      try {
        let result = await that.$api({
          method: 'get',
          url: '/bookingSite/availableDate',
          params: {
            id: that.scenic.id
          }
        })
        if (result.code === 2000 && result.result) {
          let arr = result.result
          arr = arr.filter(item => item.availible > 0)
          that.dateSlots[0].values = arr
          that.params.rdate = (arr[0] || {}).rdate
          that.getBookingTime()
        } else {
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取可用的预约日期
    async getBookingTime () {
      let that = this
      try {
        let result = await that.$api({
          method: 'get',
          url: '/bookingSite/availableTime',
          params: {
            id: that.scenic.id,
            rdate: that.params.rdate
          }
        })
        if (result.code === 2000 && result.result) {
          let arr = result.result
          arr = arr.filter(item => item.availible > 0)
          arr.map(function (item) {
            item.key = (item.beginTime + '-' + item.endTime)
          })
          that.timeSlots[0].values = arr
          that.timeSelect = arr[0] || {}
        } else {
        }
      } catch (e) {
        console.log(e)
      }
    },
    clearText (type) {
      this.params[type] = ''
    },
    // 显示弹窗
    showPop (type) {
      this[type + 'Visiable'] = true
    },
    // 取消弹窗
    cancelSelect (type) {
      this[type + 'Visiable'] = false
    },
    confirmSelect (type) {
      this[type + 'Visiable'] = false
      if (type === 'date') {
        this.params.rdate = (this.$refs[type + 'Picker'].getSlotValue(0) || {}).rdate
        this.getBookingTime()
      } else {
        this.timeSelect = this.$refs[type + 'Picker'].getSlotValue(0) || {}
      }
    },
    deleteImg () {
      this.params.facePicUrl = ''
    },
    addImg () {
      let that = this
      let file = event.target.files[0]
      lrz(file).then(function (res) {
        that.uploadFile(res.file, res.origin.name)
      })
    },
    async uploadFile (file, fname) {
      let that = this
      try {
        Indicator.open()
        let res = await that.$api({
          method: 'get',
          url: '/cloudStorage/token'
        })
        let result = res.result
        if (result.token) {
          let formData = new FormData()
          var imgLastName = fname.split('.')[1]
          var key = new Date().getTime() + '.' + imgLastName
          formData.append('key', key)
          formData.append('file', file)
          formData.append('token', result.token)
          fetch(result.uploadHost, {
            method: 'post',
            body: formData
          }).then(function (res) {
            that.params.facePicUrl = result.host + key
          }).catch(function (err) {
            console.log(err)
          })
        } else if (result.accessid) {
          let formData = new FormData()
          // let fileName = result.uploadPackage + new Date().getTime() + fname
          let fileName = new Date().getTime() + fname
          formData.append('key', fileName)
          formData.append('policy', result.policy)
          formData.append('OSSAccessKeyId', result.accessid)
          formData.append('expire', result.expire)
          formData.append('signature', result.signature)
          formData.append('file', file)
          formData.append('success_action_status', '200')
          formData.append('callback', '')
          try {
            let upRes = await fetch(result.uploadHost, {
              method: 'post',
              body: formData
            })
            console.log(upRes)
            that.params.facePicUrl = result.uploadHost + '/' + fileName
          } catch (e) {
            console.log(e)
            Toast(e)
          }
        }
        Indicator.close()
      } catch (e) {
        Indicator.close()
        Toast({
          message: '上传图片失败！',
          duration: 2000
        })
        console.log(e)
      }
    },
    // 检查手机号格式
    checkPhone (phone) {
      return /^1[3|4|5|7|8|9][0-9]\d{8}$/.test(phone)
    },
    // 检查身份证号
    checkIdCard (idCard) {
      return /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(idCard)
    },
    async submit () {
      let that = this
      let _params = that.params
      _params.id = that.scenic.id
      _params.scheduleId = that.timeSelect.id
      if (!that.submitAble) {
        return
      }
      if (!_params.name) {
        Toast({
          message: '请输入姓名',
          duration: 2000
        })
        return
      }
      if (!that.checkPhone(_params.mobile)) {
        Toast({
          message: '请输入正确的手机号码',
          duration: 2000
        })
        return
      }
      if (!that.checkIdCard(_params.idCard)) {
        Toast({
          message: '请输入有效身份证号码',
          duration: 2000
        })
        return
      }
      try {
        let result = await that.$api({
          method: 'post',
          url: '/bookingSite/booking',
          params: _params
        })
        that.setSession('status', result)
        that.$router.push({
          path: '/status',
          query: {
            from: 'form'
          }
        })
      } catch (e) {
        Toast(e)
        Indicator.close()
      }
      this.$router.push({
        path: '/status'
      })
    }
  },
  mounted () {
    let scenic = this.getSession('scenic')
    this.scenic = scenic
    this.getLastBooking()
    this.getBookingDate()
    document.title = '填写预约信息'
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-edit{
  width: 100%;
  height: 100%;
  position: relative;
  background: url('../assets/images/edit-bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: .1rem .15rem .39rem;
  .edit-scenic{
    width: 100%;
    min-height: 1.13rem;
    background: #FFFFFF;
    border: 1px solid rgba(58,127,255,0.44);
    border-radius: 6px;
    box-sizing: border-box;
    padding: .2rem .15rem;
    box-shadow: inset 0 3px 1px 2px rgba(58,127,255,0.45);
    .scenic-filed{
      width: 100%;
      min-height: .2rem;
      font-size: .14rem;
      color: #666666;
      display: flex;
      align-items: center;
      ~.scenic-filed{
        margin-top: .06rem;
      }
      .filed-name{
        font-weight: bold;
        margin-right: .09rem;
      }
    }
  }
  .edit-form{
    margin-top: .1rem;
    width: 100%;
    // height: 4.3rem;
    background: #FFFFFF;
    border: 1px solid rgba(58,127,255,0.44);
    box-shadow: 0 3px 1px rgba(58,127,255,0.45);
    border-radius: 6px;
    box-sizing: border-box;
    padding: .27rem .15rem .15rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .form-title{
      font-size: .14rem;
      color: #333333;
      font-weight: bold;
      margin-top: .15rem;
      line-height: .2rem;
      width: 100%;
    }
    .form-filed{
      width: 100%;
      min-height: .24rem;
      display: flex;
      ~.form-filed{
        margin-top: .15rem
      }
      .filed-name{
        box-sizing: border-box;
        width: .98rem;
        height: .24rem;
        line-height: .24rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: row-reverse;
        span{
          font-size: .14rem;
          color: #666666;
          position: relative;
          margin-right: .07rem;
        }
        span::before{
          content: '';
          display: block;
          height: .06rem;
          width: .06rem;
          background: url('../assets/images/require@2x.png') no-repeat;
          background-size: 100% 100%;
          position: absolute;
          left: -.08rem;
          top: 50%;
          margin-top: -.03rem;
        }
      }
      .not-require{
        span::before{
          background: none;
        }
      }
      .filed-input{
        flex: 1;
        height: .24rem;
        display: flex;
        align-items: center;
        background: rgba(97,181,255,.15);
        position: relative;
        input{
          width: 2rem;
          height: .2rem;
          line-height: .2rem;
          font-size: .14rem;
          color: #666666;
          letter-spacing: 0;
          background: none;
          border: none;
          outline: none;
          padding-left: .08rem;
        }
        .icon-arrow{
          width: .09rem;
          height: .06rem;
          display: block;
          position: absolute;
          right: .099rem;
          top: 50%;
          margin-top: -.03rem
        }
        .icon-close{
          width: .09rem;
          height: .08rem;
          display: block;
          position: absolute;
          right: .099rem;
          top: 50%;
          margin-top: -.04rem
        }
      }
      .filed-upload{
        flex: 1;
        height: .6rem;
        position: relative;
        display: flex;
        .uplaod-area{
          border: 1px dashed #D3D2D2;
          border-radius: 2px;
          width: .6rem;
          height: .6rem;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: .25rem;
            height: .21rem;
            display: block;
          }
          input{
            display: block;
            position: absolute;
            width: .6rem;
            height: .6rem;
            border: none;
            outline: none;
            opacity: 0;
            left: 0;
            top: 0;
          }
        }
        .uplaod-img{
          width: .6rem;
          height: .6rem;
          border-radius: 2px;
          overflow: hidden;
          position: relative;
          img{
            width: 100%;
            height: 100%;
            display: block;
          }
          a{
            width: .1rem;
            height: .1rem;
            display: block;
            background: url('../assets/images/close1@2x.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
      .uplaod-text{
        flex: 1;
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 12px;
        color: #999999;
        margin-left: 8px;
      }
    }
    .form-btn{
      width: 2.53rem;
      height: .36rem;
      background-image: linear-gradient(270deg, rgba(143,159,191,.27) 0%, rgba(90,121,182,.27) 100%);
      box-shadow: 0 2px 4px 0 rgba(67,107,196,0.27);
      border-radius: .18rem;
      font-size: .14rem;
      color: #FFFFFF;
      text-align: center;
      line-height: .36rem;
      margin-top: .4rem;
    }
    .btn-enabled{
      background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
      box-shadow: 0 2px 4px 0 rgba(67,107,196,0.5);
    }
  }
  .pop-photo{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .video-box{
      width: 2.95rem;
      height: 2.95rem;
      background: url('../assets/images/face-border.png') no-repeat;
      background-size: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: .6rem;
      padding: .17rem;
      .pop-video{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .pop-snap{
      width: .74rem;
      height: .74rem;
      background: url('../assets/images/xiangji@2x.png') no-repeat;
      background-size: 100%;
      margin-top: .82rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ReservationEdit.vue